module.exports = __webpack_public_path__ + "img/copy-icon-blue.80f22503.svg";